import { render, staticRenderFns } from "./render-information.vue?vue&type=template&id=155bd0e3&"
import script from "./render-information.vue?vue&type=script&lang=ts&"
export * from "./render-information.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports